const borderRadius = {
  0: 0,
  50: 2,
  100: 4,
  150: 6,
  200: 8,
  300: 12,
  400: 16,
  500: 20,
  600: 24,
} as const;

export default borderRadius;
